import React, { useState } from "react"
import { Link, graphql, useStaticQuery} from "gatsby"
import { rhythm, scale } from "../utils/typography"
import { ThemeToggler } from 'gatsby-plugin-dark-mode'
import '../styles/index.css'

const theme = {
  light: 'light',
  dark: 'dark'
}

const Layout = ({ location, title, children }) => {
  const [toggle, setToggle] = useState(theme.light);
  const data = useStaticQuery(graphql`
  query {
    site {
      siteMetadata {
        author {
          name
          summary
        }
      }
    }
  }
  `)
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  if (location.pathname === rootPath) {
    header = (
      <h1
        style={{
          ...scale(0.5),
          marginBottom: rhythm(2),
          marginTop: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h1>
    )
  } else {
    header = (
      <h3
        style={{
          fontFamily: `Montserrat, sans-serif`,
          marginTop: 1,
          color: `var(--date)`
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h3>
    )
  }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(29),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        backgroundColor: `var(--bg)`,
        color: `var(--textNormal)`,
        marginTop: `0px`,
        marginBottom:`0px`,
        borderRadius: `10px`,
      }}
    >
      <header style={{ textAlign:'center', marginBottom: rhythm(4/4) }}>
      <ThemeToggler>
        {({ theme, toggleTheme }) => (
          <label className="switch">
            <input
              type="checkbox"
              onChange={e => toggleTheme(e.target.checked ? 'dark' : 'light')}
              checked={theme === 'dark'}
            />{' '}
          <span class="slider round"></span>
          </label>
        )}
      </ThemeToggler>
      </header>
      <header style={{ textAlign: "center", }}>{header}</header>
    <main className="body-blog">{children}</main>
    <footer style={{ textAlign: "center", color: `var(--textNormal)`, marginTop: `20px`}}>
        © {new Date().getFullYear()}, Utkarsh Yadav
        {` `}
       . All Rights Reserved
      </footer>
    </div>
  )
}

export default Layout
